import { onMounted, watch } from "vue";
import type { Ref } from "vue";
import type { DSFileUploadComponentProps, DSFileUploadModelValue } from "../types";

interface UseDSFileUploadInputSyncOptions {
  props: DSFileUploadComponentProps;
  modelValue: Readonly<Ref<DSFileUploadModelValue>>;
  setInputFiles: (files: File[]) => void;
}

export function useDSFileUploadInputSync({ props, modelValue, setInputFiles }: UseDSFileUploadInputSyncOptions) {
  function syncInputFiles(nextModelValue: DSFileUploadModelValue): void {
    setInputFiles(filesFromModelValue(nextModelValue));
  }

  function filesFromModelValue(nextModelValue: DSFileUploadModelValue): File[] {
    return nextModelValue.flatMap(item => (item.file ? [item.file] : []));
  }

  onMounted(() => {
    syncInputFiles(modelValue.value);
  });

  watch(
    () => props.modelValue,
    value => {
      syncInputFiles(value ?? []);
    },
    { deep: true, flush: "post" }
  );

  return {
    syncInputFiles,
  };
}
